import { render } from "./Tem021.vue?vue&type=template&id=2b9f2056"
import script from "./Tem021.vue?vue&type=script&lang=js"
export * from "./Tem021.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__